
import ConfirmTicket from "./ConfirmationTicket";
const FlightConfirmationArea = () => {
    return (
        <>
            <section id="tour_booking_submission" className="section_padding">
                <ConfirmTicket/>
            </section>
        </>
    );
};

export default FlightConfirmationArea;
